import { startTransition } from 'react';
import { AssetItemDto } from '@api/Api';
import { MarqueeItem } from '@hooks/useMarqueeSelection';

export function applyMarqueeAssetSelection({
  items,
  foldersList,
  assetsList,
  setSelectedFolders,
  setSelectedAssets
}: {
  items: MarqueeItem[];
  foldersList: { node: AssetItemDto; cursor: string }[];
  assetsList: { node: AssetItemDto; cursor: string }[];
  setSelectedFolders: (
    updater: (
      prev: { node: AssetItemDto; cursor: string }[]
    ) => { node: AssetItemDto; cursor: string }[]
  ) => void;
  setSelectedAssets: (
    updater: (
      prev: { node: AssetItemDto; cursor: string }[]
    ) => { node: AssetItemDto; cursor: string }[]
  ) => void;
}) {
  if (!items.length) return;

  const folderIds = new Set(
    items.filter((item) => item.type === 'folder').map((item) => item.id)
  );
  const assetIds = new Set(
    items.filter((item) => item.type === 'asset').map((item) => item.id)
  );

  startTransition(() => {
    if (folderIds.size) {
      setSelectedFolders((prev) => {
        const byId = new Map(prev.map((folder) => [folder.node.id, folder]));
        foldersList.forEach((folder) => {
          if (folderIds.has(folder.node.id)) {
            byId.set(folder.node.id, folder);
          }
        });
        return [...byId.values()];
      });
    }

    if (assetIds.size) {
      setSelectedAssets((prev) => {
        const byId = new Map(prev.map((asset) => [asset.node.id, asset]));
        assetsList.forEach((asset) => {
          if (assetIds.has(asset.node.id)) {
            byId.set(asset.node.id, asset);
          }
        });
        return [...byId.values()];
      });
    }
  });
}
